import NewsletterSubscriptionStyles from '../styles/NewsletterSubscription.module.css'; // Import the CSS module

const NewsletterSubscription = () => {

    return (
        <div className={NewsletterSubscriptionStyles.container}>
          
          <div className={NewsletterSubscriptionStyles.content}>
            <h2>Subscribe to our newsletter</h2>
            <p>
              Stay up to date with the latest news, product updates, and exclusive insights delivered
              straight to your inbox. Join our community and never miss a beat.
            </p>
          </div>

          <div className={NewsletterSubscriptionStyles.form}>
            <input type="email" placeholder="Write your email here..." />
            <button type="submit">Subscribe</button>
            {/* <small>
              By subscribing, you agree to our <a href="/privacy">Privacy Policy</a>.
            </small> */}
          </div>

        </div>
    );
}

export default NewsletterSubscription;